import * as Yup from 'yup';

const ValidationEditCertificated = Yup.object({
  password: Yup.string().required('La contraseña es requerida'),
  file: Yup.mixed().required('El archivo es requerido'),
});

export default ValidationEditCertificated;